import axios from 'axios';
import slugify from 'slugify';
import { isLocalStorageAvailable } from '../../../utils';

const ACTIONS = {
  SET_INVESTMENT(context, name) {
    if (!name) {
      context.commit('SET_INVESTMENT', null);
      context.commit('CLEAR_FLATS');
      return false;
    }

    let investmentName = slugify(name, {
      lower: true,
    });

    let investment = context.state.investments.get(investmentName) || null;
    if (investment) {
      context.commit('SET_INVESTMENT', investment);
      context.dispatch('FETCH_FLATS', investment);
    } else {
      context.commit('SET_INVESTMENT', null);
      context.commit('CLEAR_FLATS');
    }
  },
  FETCH_FLATS(context, investment = null) {
    if (!investment) {
      throw new Error('Incorrect investment.');
    }

    // Checking if flats are already cached
    let flats = null;
    if (isLocalStorageAvailable()) {
      flats = JSON.parse(
        sessionStorage.getItem(`flats.${investment.investmentName}`)
      );
    }
    if (flats) {
      context.commit('CLEAR_FLATS');
      context.commit('PUSH_FLATS', [...flats]);
    } else {
      context.commit('FETCHING_FLATS');
      axios
        .get(investment.flatsUrl)
        .then(response => {
          const balticWaveData = response.data.filter(({ investments_name }) =>
            investments_name.toLowerCase().includes('baltic wave')
          );

          let data = [
            ...balticWaveData.map(flat => {
              let amenities = [];
              const balconyArea = Number(flat.area_balcony.replace(/,/g, '.'));

              if (balconyArea && balconyArea > 0) {
                amenities.push('balkon');
              }
              return {
                ...flat,
                balcony: balconyArea,
                amenities,
              };
            }),
          ];

          context.commit('FETCHED_FLATS');
          context.commit('CLEAR_FLATS');
          context.commit('PUSH_FLATS', data);

          if (isLocalStorageAvailable()) {
            sessionStorage.setItem(
              `flats.${investment.investmentName}`,
              JSON.stringify(data)
            );
          }
        })
        .catch(error => {
          context.commit('FETCHED_FLATS');
          console.error(error);
        });
    }
  },
  FETCH_FAVOURITES(context) {
    if (isLocalStorageAvailable()) {
      if (localStorage.favourites) {
        if (JSON.parse(localStorage.favourites).some(el => !el)) {
          return localStorage.clear();
        }
        context.commit(
          'ADD_TO_FAVOURITES',
          JSON.parse(localStorage.favourites)
        );
      }
    }
  },
  TOGGLE_AMENITY(context, amenity) {
    let filters = context.state.filters.map(filter => filter.property);

    if (filters.includes(amenity)) {
      context.commit('DELETE_FILTER', { property: amenity });
    } else {
      context.commit('ADD_FILTERS', { property: amenity, equal: true });
    }
  },
};

export default ACTIONS;
